
// latest

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import { userPool } from '../cognito/UserPool';
import backgroundImage from '../assets/images/backgroundImage.png';

function LoginPage({ PlutonicuserID, currentNickname, setCurrentNickname, handleLogout }) {
  const [formType, setFormType] = useState(() => localStorage.getItem('formType') || 'login');
  const [isLoading, setIsLoading] = useState(true);
  // const [PlutonicuserID, setPlutonicuserID] = useState(() => localStorage.getItem('PlutonicuserID'));
  const navigate = useNavigate();

  useEffect(() => {
    const savedNickname = localStorage.getItem('currentNickname'); // Use consistent key
    const savedPlutonicuserID = localStorage.getItem('PlutonicuserID');

    if (savedNickname && savedPlutonicuserID) {
      // console.log('[LoginPage] Restoring nickname and userID from localStorage:', savedNickname, savedPlutonicuserID);
      setCurrentNickname(savedNickname);
      // setPlutonicuserID(savedPlutonicuserID);
      navigate('/therapy-rooms'); // Redirect if authenticated
      return;
    }

    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err || !session.isValid()) {
          // console.log('[LoginPage] Invalid session. Redirecting to login.');
          setFormType('login');
          setIsLoading(false);
          return;
        }

        cognitoUser.getUserAttributes((err, attributes) => {
          setIsLoading(false);
          if (err || !attributes) {
            // console.log('[LoginPage] Failed to fetch user attributes.');
            setFormType('login');
            return;
          }

          const nicknameAttr = attributes.find(attr => attr.Name === 'nickname' || attr.Name === 'custom:nickname');
          const userIDAttr = attributes.find(attr => attr.Name === 'custom:PlutonicuserID');

          const userNickname = nicknameAttr ? nicknameAttr.Value : '';
          const id = userIDAttr ? userIDAttr.Value : null;

          if (userNickname && id) {
            // console.log('[LoginPage] Session valid. Setting nickname and userID:', userNickname, id);
            setCurrentNickname(userNickname);
            // setPlutonicuserID(id);
            localStorage.setItem('currentNickname', userNickname);
            localStorage.setItem('PlutonicuserID', id);
            navigate('/therapy-rooms'); // Redirect after session validation
          }
        });
      });
    } else {
      setIsLoading(false);
    }
  }, [setCurrentNickname, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="relative h-screen w-full flex flex-col items-center justify-start overflow-hidden">
      <img src={backgroundImage} alt="background" className="absolute inset-0 w-full h-full object-cover" />
      <Navbar
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setFormType={setFormType}
        showButtons={false}
        PlutonicuserID={PlutonicuserID}
      />

      <div className="relative flex flex-col items-center justify-center w-full h-full">
        <div className="relative flex flex-col justify-center items-center z-0 w-[90%] max-w-[500px] h-[90%] max-h-[550px] sm:w-[80%] sm:h-[80%] md:w-[70%] md:h-[70%] p-4">
          <div
            className="relative z-20 text-center text-2xl font-bold text-black mb-6 lg:hidden"
            style={{ fontFamily: 'Poppins-Semibold, Poppins, sans-serif' }}
          >
            Therapy Built for You
          </div>
          <div className="relative z-20 mt-4">
            {formType === 'login' ? (
              <LoginForm
                currentNickname={currentNickname}
                setCurrentNickname={(nickname) => {
                  // console.log('[LoginPage] Updating nickname to:', nickname);
                  setCurrentNickname(nickname);
                  localStorage.setItem('currentNickname', nickname);
                }}
                formType={formType}
                setFormType={setFormType}
                onLoginSuccess={(nickname, id) => {
                  // console.log('[LoginPage] Login success. Setting nickname and userID:', nickname, id);
                  setCurrentNickname(nickname);
                  // setPlutonicuserID(id);
                  localStorage.setItem('currentNickname', nickname);
                  localStorage.setItem('PlutonicuserID', id);
                  navigate('/therapy-rooms'); // Redirect after successful login
                }}
              />
            ) : (
              <ResetPasswordForm setFormType={setFormType} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;




